import {
  fetchCorporatePortfolioSummary,
  fetchPortfolioSummary,
  type ClientPortfolioSummary,
} from "@/domain/clients/client-detail";
import { mapWithConcurrency } from "@/shared/concurrency";

export { mapWithConcurrency };

export const PORTFOLIO_FANOUT_CONCURRENCY = 5;

const SUMMARY_TTL_MS = 45_000;

type CacheEntry = { value: ClientPortfolioSummary | null; expires: number };
const summaryCache = new Map<string, CacheEntry>();

export async function cachedPortfolioSummary(
  individualId: string,
): Promise<ClientPortfolioSummary | null> {
  return cached(`individual:${individualId}`, () => fetchPortfolioSummary(individualId));
}

export async function cachedCorporatePortfolioSummary(
  corporationClientId: string,
): Promise<ClientPortfolioSummary | null> {
  return cached(`corporation:${corporationClientId}`, () =>
    fetchCorporatePortfolioSummary(corporationClientId),
  );
}

export function invalidatePortfolioSummary(
  kind: "individual" | "corporation",
  clientId: string,
): void {
  summaryCache.delete(`${kind}:${clientId}`);
}

async function cached(
  key: string,
  read: () => Promise<ClientPortfolioSummary | null>,
): Promise<ClientPortfolioSummary | null> {
  const now = Date.now();
  const hit = summaryCache.get(key);
  if (hit && hit.expires > now) return hit.value;

  const value = await read();
  summaryCache.set(key, { value, expires: now + SUMMARY_TTL_MS });
  return value;
}
